import { render } from "./CategoriesSectionComponent.vue?vue&type=template&id=97c0db9c&scoped=true"
import script from "./CategoriesSectionComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesSectionComponent.vue?vue&type=script&lang=js"

import "./CategoriesSectionComponent.vue?vue&type=style&index=0&id=97c0db9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c0db9c"]])

export default __exports__